export default function inputEvent(input, btnConfirm) {
  if (input.value === '' && input.classList.contains('required')) {
    input.classList.add('has-error');
  } else {
    btnConfirm.classList.remove('display--none');
  }
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/events/inputEvent.js